<template>
  <layout-auth>
    <v-form>
      <v-container class="py-10">
        <v-row>
          <v-col>
            <h1 class="text-h4 font-weight-light py-5">
              {{ $t("accounts.confirmAddTitle") }}
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col :hidden="!case6s">
            <h2 class="text-h5 font-weight-light">
              {{ $t("accounts.datosOperacion") }}
            </h2>

            <h2 class="text-h5 font-weight-light">
              {{ $t("accounts.estado") }}
            </h2>

            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("invoices.descargarnecitadjuntarCertificado") }}
            </h3>
          </v-col>

          <v-col :hidden="!case4">
            <h2 class="text-h5 font-weight-light">
              {{ $t("accounts.datosOperacion") }}
            </h2>

            <h2 class="text-h5 font-weight-light">
              {{ $t("accounts.estado") }}
            </h2>

            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("accounts.necitadjuntarCertificado") }}
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("accounts.accountDataSubtitle") }}
            </h2>

            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("accounts.confirmAddSubtitle") }}
            </h3>
          </v-col>
        </v-row>
        <v-row class="py-10">
          <v-col cols="12" sm="12" md="6" lg="4">
            <label class="second-type-label">{{ $t("accounts.accountNumber") }}</label>
            <p>{{ model.iban }}</p>
          </v-col>
          <v-col :hidden="model.bic === ''" cols="12" sm="12" md="6" lg="4">
            <label class="second-type-label">{{ $t("accounts.bic") }}</label>
            <p>{{ model.bic }}</p>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="4">
            <label class="second-type-label">{{ $t("accounts.description") }}</label>
            <p>{{ model.description }}</p>
          </v-col>
        </v-row>

        <v-row class="py-10">
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              :hidden="!ocultarBtn4"
              :disabled="disabledDocumen"
              v-if="!confirmed"
              :style="`color: ${entityConfig.secondaryColor}`"
              @click="post_created_account_s3"
              depressed
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.confirm") }}
            </v-btn>

            <v-btn
              :hidden="!ocultarBtn3"
              :disabled="disabledDocumen"
              v-if="!confirmed"
              :style="`color: ${entityConfig.secondaryColor}`"
              @click="post_created_account_s3"
              depressed
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.confirm") }}
            </v-btn>

            <v-btn
              :hidden="!ocultarBtn2"
              :disabled="!disabledDocumen"
              v-if="!confirmed"
              :style="`color: ${entityConfig.secondaryColor}`"
              @click="post_created_account_n2"
              depressed
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.finish") }}
            </v-btn>

            <v-btn
              v-else
              depressed
              @click="finalizar"
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.finish") }}
            </v-btn>

            <v-btn
              v-if="confirmed"
              @click="$router.go(-1)"
              outlined
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.goBack") }}
            </v-btn>

            <v-btn
              v-else
              plain
              @click="print"
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              <v-icon left> mdi-printer-outline </v-icon>
              {{ $t("supplierData.print") }}
            </v-btn>

            <v-btn
              v-if="!confirmed"
              :hidden="!ocultarBtn3"
              :loading="isSelecting"
              @click="handleFileImport"
              :style="`color: ${entityConfig.secondaryColor}`"
              depressed
              :color="entityConfig.primaryColor"
              class="float-end m-2"
            >
              {{ $t("accounts.adjuntarDocumentacion") }}
            </v-btn>

            <v-btn
              v-if="!confirmed"
              :href="entityConfig.titularidad"
              :hidden="!ocultarBtn3"
              :style="`color: ${entityConfig.secondaryColor}`"
              depressed
              :color="entityConfig.primaryColor"
              class="float-end m-2"
              target="_blank"
            >
              {{ $t("accounts.descargarVerificacionTituaridad") }}
            </v-btn>

            <v-btn
              v-if="!confirmed"
              :hidden="!ocultarBtn4"
              :loading="isSelecting"
              @click="handleFileImport"
              :style="`color: ${entityConfig.secondaryColor}`"
              depressed
              :color="entityConfig.primaryColor"
              class="float-end m-2"
            >
              {{ $t("accounts.adjuntarDocumentacion") }}
            </v-btn>

            <input
              @change="onFileChanged"
              ref="uploader"
              class="d-none"
              type="file"
              accept="application/pdf,image/jpg,image/png,image/jpeg"
            />
          </v-col>
          <v-col><label class="float-end m-2">{{ $t("accounts.antiguedadPngJpejPDF") }}</label></v-col>
        </v-row>
        <overlay :visible="spinner" :opacity="1"></overlay>
      </v-container>
    </v-form>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import { mapState } from "vuex";
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";

export default {
  components: {
    "layout-auth": LayoutAuth,
    Overlay,
  },
  data: () => ({
    userId: "",
    ocultarBtn2: false,
    ocultarBtn3: false,
    ocultarBtn4: false,

    confirmed: false,
    userdata: {},
    response: "",
    form: {
      iban: "",
      description: "",
      bic: "",
    },
    isSelecting: false,
    document: null,
    spinner: false,
    checkbox: true,
    model: { iban: "", description: "", bic: "" },
    entityConfig: {},
    case4: false,
    case6s: false,
    documentExt: "",
    variable: "",
    iberpayValidate: false,
  }),

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");

    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.userId = this.userdata.supplierId.trim();

    let newAccount = JSON.parse(sessionStorage.getItem("accountConfirm"));
    if (newAccount) {
      this.model = newAccount;
      Api.defaults.headers.common["Authorization"] =
        "Bearer " + sessionStorage.getItem("authtoken");
    } else {
      this.$router.go(-1);
    }

    let newAccount2 = JSON.parse(sessionStorage.getItem("response"));
    if ((newAccount2, newAccount)) {
      this.response = newAccount2;
      this.variable = newAccount;
      if (this.response.response.codEcvEgc === "2") {
        this.ocultarBtn2 = true;
        sessionStorage.removeItem("response");
      }

      if (
        this.response.response.codEcvEgc === "6" &&
        this.response.response.indSitVal === "S"
      ) {
        this.ocultarBtn3 = true;
        this.case6s = true;
        sessionStorage.removeItem("response");
      }

      if (
        // con modal para cuenta
        this.response.response.codEcvEgc === "6" &&
        this.response.response.indSitVal === "N" &&
        this.variable.bic !== " "
      ) {
        this.ocultarBtn4 = true;
        this.case4 = true;
        sessionStorage.removeItem("response");
      }

      if (
        this.response.response.codEcvEgc === "6" &&
        this.response.response.indSitVal === "N" &&
        this.variable.bic === " "
      ) {
        this.ocultarBtn4 = true;
        this.case4 = true;
        sessionStorage.removeItem("response");
      }
    }
  },

  computed: {
    ...mapState("account", ["iban", "description"]),

    disabledDocumen() {
      return this.document === null;
    },
  },

  methods: {
    handleFileImport() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      var status = "";
      if (
        this.response.response.codEcvEgc == "6" &&
        this.response.response.indSitVal == "S"
      ) {
        status = "|V";
      }

      let file = e.target.files[0];
      let reader = new FileReader();

      this.documentExt = file.type.split("/")[1] + status;
      let that = this;
      reader.onloadend = function () {
        that.document = reader.result.replace(/^data:.+;base64,/, "");
      };

      reader.readAsDataURL(file);
    },

    print() {
      window.print();
    },
    async post_created_account_s3() {
      try {
        let message = "Su cuenta ha quedado pendiente de validación";
        this.spinner = true;
        const formData = new FormData();
        formData.append("iban", this.model.iban);
        formData.append("bic", this.model.bic);
        formData.append("description", this.model.description);
        formData.append("document", this.document);
        formData.append("ext", this.documentExt);
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        const obj = Object.fromEntries(formData);
        await Api.put(`/proveedores/${this.userId}/cuentas-abono`, obj);

        this.spinner = false;
        this.$toast.success(message);
        sessionStorage.removeItem("accountConfirm");
        this.confirmed = true;
        this.$router.push({ path: "/cuentas-de-abono" });
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },

    async post_created_account_n2() {
      sessionStorage.removeItem("accountConfirm");
      this.$router.push({ path: "/cuentas-de-abono" });
    },

    volver() {
      this.$router.push({
        path: "/cuentas-de-abono",
        query: { goBack: true },
      });
    },
    finalizar() {
      this.$router.push({ path: "/cuentas-de-abono" });
    },
  },
};
</script>
